import React, { useEffect } from 'react';

function checkForIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
function GoogleTagManager(_a) {
    var gtmId = _a.gtmId, _b = _a.event, event = _b === void 0 ? 'pageview' : _b, article_id = _a.article_id, article_title = _a.article_title, _c = _a.article_type, article_type = _c === void 0 ? 'interactive-standalone' : _c, article_length = _a.article_length, _d = _a.pagetype, pagetype = _d === void 0 ? 'content' : _d, category = _a.category, subcategory = _a.subcategory, _e = _a.premium, premium = _e === void 0 ? 0 : _e, publish_date = _a.publish_date, _f = _a.author_name, author_name = _f === void 0 ? '' : _f;
    var pageViewConfig = {
        event: event,
        article_id: article_id,
        article_title: article_title,
        article_type: article_type,
        article_length: article_length,
        pagetype: pagetype,
        category: category,
        subcategory: subcategory,
        premium: premium,
        publish_date: publish_date,
        author_name: author_name
    };
    useEffect(function () {
        window.dataLayer = window.dataLayer || [];
        console.debug('[GoogleTagManager] DataLayer has been set up');
    }, []);
    useEffect(function () {
        if (gtmId) {
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = '';
                j.async = true;
                j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', gtmId);
            console.debug('[GoogleTagManager] GTM Scripts have been set up using ID ' + gtmId);
            return;
        }
        console.debug('[GoogleTagManager] No GTM ID has been provided, not setting up GTM Scripts');
    }, [gtmId]);
    useEffect(function () {
        if (checkForIframe()) {
            window.dataLayer.push({
                event: 'iframeload',
                pagetype: 'embedded content',
                category: 'interactive'
            });
            console.debug('[GoogleTagManager] Pushing iframeload event');
            return;
        }
        window.dataLayer.push(pageViewConfig);
        console.debug('[GoogleTagManager] Pushing pageview event');
    }, [checkForIframe()]);
    if (gtmId) {
        return (React.createElement("noscript", null,
            React.createElement("iframe", { src: "//www.googletagmanager.com/ns.html?id=" + gtmId, height: '0', width: '0', style: {
                    display: 'none',
                    visibility: 'hidden',
                    position: 'absolute'
                } })));
    }
    return null;
}

export { GoogleTagManager };
//# sourceMappingURL=index.m.js.map
